import moment from 'moment';
import { isFunction } from 'lodash';
export default function formatDateValue(value, displayFormat) {
  // HACK: to support date libs other than moment, we check for a `toDate` method
  // here, if its available we create a new moment object with its output
  var maybeMomentValue = value && value.toDate && !moment.isMoment(value) ? moment(value.toDate()) : value; // Check if value is a moment object (since the date input expects that as a value),
  // if so, format depending on what `displayFormat` is ... if value is not a valid
  // moment object, return empty string

  return moment.isMoment(maybeMomentValue) ? displayFormat ? isFunction(displayFormat) ? displayFormat(maybeMomentValue) : maybeMomentValue.format(displayFormat) : maybeMomentValue : '';
}